import Vue from "vue";
import Router from "vue-router";
import Store from "@/store/index.js";
import AppConsts from "@/store/consts.js";
import Permissions from "@/routes/permissions.js";
import memberService from "@/services/memberService.js";

import Home from "@/views/Home.vue";
import Notice from "@/views/tickets/Notice.vue";
import Login from "@/views/Login.vue";
import MemberCenter from "@/views/MemberCenter.vue";
import CreateOrder from "@/views/orders/CreateOrder.vue";
import CreateGroupOrder from "@/views/orders/CreateGroupOrder.vue";
import CreateGroupOrderByAdmin from "@/views/orders/CreateGroupOrderByAdmin.vue";
import Order from "@/views/orders/Order.vue";
import OrderInfo from "@/views/orders/OrderInfo.vue";
import RefundTicket from "@/views/orders/RefundTicket.vue";
import RefundDetail from "@/views/orders/RefundDetail.vue";
import MyTicket from "@/views/MyTicket.vue";
import GroupLogin from "@/views/GroupLogin.vue";
import GroupRegist from "@/views/GroupRegist.vue";
import GroupRegistSuccess from "@/views/GroupRegistSuccess.vue";
import ErrorInfo from "@/views/ErrorInfo.vue";
import RegistMemberCard from "@/views/RegistMemberCard.vue";
import MemberCard from "@/views/MemberCard.vue";
import BindStaff from "@/views/BindStaff.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import DeliverOrdersOnBehalf from "@/views/DeliverOrdersOnBehalf.vue";
import DeliverOrdersOnBehalf1 from "@/views/DeliverOrdersOnBehalf1.vue";
import SubscribeWeChat from "@/views/SubscribeWeChat.vue";
import TemporaryReservationCode from "@/views/TemporaryReservationCode.vue";
import CarKeyBoard from "@/views/CarKeyBoard.vue";
import Help from "@/views/Help.vue";
import BuyTicket from "@/views/tickets/BuyTicket.vue";
import WxJsPay from "@/views/payments/WxJsPay.vue";
const GroupExplain = () => import("@/views/GroupExplain.vue");
const QueryGroupExplain = () => import("@/views/QueryGroupExplain.vue");
const GroupCheckTicket = () => import("@/views/GroupCheckTicket.vue");
const TouristStat = () => import("@/views/report/TouristStat.vue");
const ComprehensiveReport = () =>
  import("@/views/report/ComprehensiveReport.vue");
const PassengerFlowStat = () => import("@/views/report/PassengerFlowStat.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录",
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "首页",
        tabbarActiveIndex: 0,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/notice/:exhibitionHall",
      name: "notice",
      component: Notice,
      props: true,
      meta: {
        title: "预约须知",
        tabbarActiveIndex: 0,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/buyticket/:publicSaleFlag",
      name: "buyticket",
      component: BuyTicket,
      props: true,
      meta: {
        title: "提交订单"
      }
    },
    {
      path: "/WxJsPay/:listNo/:payTitle",
      name: "wxjspay",
      component: WxJsPay,
      props: true,
      meta: {
        title: "支付订单"
      }
    },
    {
      path: "/order",
      name: "order",
      component: Order,
      meta: {
        title: "订单",
        tabbarActiveIndex: 1,
        showTabbar: true
      }
    },
    {
      path: "/my",
      name: "my",
      component: MemberCenter,
      meta: {
        title: "我的",
        navbarColor: "blue",
        tabbarActiveIndex: 3,
        showTabbar: true
      }
    },
    {
      path: "/help",
      name: "help",
      component: Help,
      meta: {
        title: "获取帮助",
        navbarColor: "blue",
        tabbarActiveIndex: 2,
        showTabbar: true,
        allowAnonymous: true
      }
    },
    {
      path: "/createorder/:addChildren/:ticketTypeIds",
      name: "createorder",
      component: CreateOrder,
      props: true,
      meta: {
        title: "散客领票"
      }
    },
    {
      path: "/orderinfo/:listNo",
      name: "orderinfo",
      component: OrderInfo,
      props: true,
      meta: {
        title: "订单明细"
      }
    },
    {
      path: "/refundticket/:listNo",
      name: "refundticket",
      component: RefundTicket,
      props: true,
      meta: {
        title: "取消订单"
      }
    },
    {
      path: "/refunddetail/:listNo",
      name: "refunddetail",
      component: RefundDetail,
      props: true,
      meta: {
        title: "退款详情"
      }
    },
    {
      path: "/myticket",
      name: "myticket",
      component: MyTicket,
      meta: {
        title: "我的门票"
      }
    },
    {
      path: "/grouplogin/:shouldBind/:nextPath/:ticketTypeIds",
      name: "grouplogin",
      component: GroupLogin,
      props: true,
      meta: {
        title: "团队登录"
      }
    },
    {
      path: "/groupregist",
      name: "groupregist",
      component: GroupRegist,
      props: route => ({ customerId: route.query.customerId }),
      meta: {
        title: "团队注册"
      }
    },
    {
      path: "/deliverordersonbehalf",
      name: "deliverordersonbehalf",
      component: DeliverOrdersOnBehalf,
      meta: {
        title: "代客下单"
      }
    },
    {
      path: "/deliverordersonbehalf1/:listNo/:dateTime/:parkId/:memberId/:explainFlag",
      name: "deliverordersonbehalf1",
      component: DeliverOrdersOnBehalf1,
      props: true,
      meta: {
        title: "临时下单"
      }
    },
    {
      path: "/temporaryReservationCode",
      name: "temporaryReservationCode",
      component: TemporaryReservationCode,
      meta: {
        title: "临时下单码"
      }
    },
    {
      path: "/groupregistsuccess",
      name: "groupregistsuccess",
      component: GroupRegistSuccess,
      meta: {
        title: "注册成功"
      }
    },
    {
      path: "/changepassword/:forgetPassword/:customerId/:dateTime/:lastChangePasswordTime",
      name: "changepassword",
      props: true,
      component: ChangePassword,
      meta: {
        title: "修改密码"
      }
    },
    {
      path: "/creategrouporder/:ticketTypeIds",
      name: "creategrouporder",
      component: CreateGroupOrder,
      props: true,
      meta: {
        title: "团队预约"
      }
    },
    {
      path: "/creategrouporderbyadmin/:ticketTypeIds",
      name: "creategrouporderbyadmin",
      component: CreateGroupOrderByAdmin,
      props: true,
      meta: {
        title: "团队预约"
      }
    },
    {
      path: "/errorinfo",
      name: "errorinfo",
      component: ErrorInfo,
      meta: {
        title: "操作失败",
        showNavbar: false,
        allowAnonymous: true
      }
    },
    {
      path: "/registmembercard",
      name: "registmembercard",
      component: RegistMemberCard,
      meta: {
        title: "注册散客会员"
      }
    },
    {
      path: "/membercard",
      name: "membercard",
      component: MemberCard,
      meta: {
        title: "电子会员码",
        tabbarActiveIndex: 2
      }
    },
    {
      path: "/bindstaff",
      name: "bindstaff",
      component: BindStaff,
      meta: {
        title: "员工绑定"
      }
    },
    {
      path: "/groupexplain",
      name: "groupexplain",
      component: GroupExplain,
      meta: {
        title: "团队讲解",
        permission: Permissions.TMSWeChat_GroupExplain
      }
    },
    {
      path: "/querygroupexplain",
      name: "querygroupexplain",
      component: QueryGroupExplain,
      meta: {
        title: "讲解查询",
        permission: Permissions.TMSWeChat_QueryGroupExplain
      }
    },
    
    {
      path: "/groupcheckticket",
      name: "groupcheckticket",
      component: GroupCheckTicket,
      meta: {
        title: "团队检票",
        permission: Permissions.TMSWeChat_GroupCheck
      }
    },
    {
      path: "/ComprehensiveReport",
      name: "ComprehensiveReport",
      component: ComprehensiveReport,
      meta: {
        title: "综合报表",
        permission: Permissions.TMSWeChat_ComprehensiveReport
      }
    },
    {
      path: "/touriststat",
      name: "touriststat",
      component: TouristStat,
      meta: {
        title: "游客统计",
        permission: Permissions.TMSWeChat_TouristStat
      }
    },
    {
      path: "/PassengerFlowStat",
      name: "PassengerFlowStat",
      component: PassengerFlowStat,
      meta: {
        title: "客流量分析",
        permission: Permissions.TMSWeChat_PassengerFlowStat
      }
    },
    {
      path: "/SubscribeWeChat",
      name: "SubscribeWeChat",
      component: SubscribeWeChat,
      meta: {
        title: "关注微信公众号",
        allowAnonymous: true
      }
    },
    {
      path: "/carKeyBoard",
      name: "carKeyBoard",
      component: CarKeyBoard,
      meta: {
        title: "车牌"
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      const position = {};
      if (to.hash) {
        position.selector = to.hash;
      }
      if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0;
        position.y = 0;
      }
      return position;
    }
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name === "login" && from.name) {
    next(false);
    return;
  }
  if (!await ensureLogined(to, next)) {
    return;
  }

  if (to.meta.permission) {
    if (
      !Store.state.memberModule.member.permissions.some(
        p => p.toLowerCase() === to.meta.permission.toLowerCase()
      )
    ) {
      next(false);
      return;
    }
  }

  window.document.title = to.meta.title;
  Store.commit(AppConsts.setTitle, to.meta.title);

  let showNavbar = to.meta.showNavbar;
  if (showNavbar === undefined) {
    showNavbar = true;
  }
  Store.commit(AppConsts.setShowNavbar, showNavbar);

  let navbarColor = to.meta.navbarColor;
  if (navbarColor === undefined) {
    navbarColor = "white";
  }
  Store.commit(AppConsts.setNavbarColor, navbarColor);

  let showTabbar = to.meta.showTabbar;
  if (showTabbar === undefined) {
    showTabbar = false;
  }
  Store.commit(AppConsts.setShowTabbar, showTabbar);

  if (to.meta.tabbarActiveIndex !== undefined) {
    Store.commit(AppConsts.activeTabbar, to.meta.tabbarActiveIndex);
  }

  next();
});

async function ensureLogined(to, next) {
  if (to.meta.allowAnonymous) {
    next(true);
    return true;
  }
  if (Store.state.memberModule.member && Store.state.memberModule.member.id) {
    next(true);
    return true;
  }

  let loginUrl = `${location.origin}/Login?redirect=${to.path}`;
  if (location.search) {
    loginUrl += location.search.replace("?", "&");
  }

  let wxLoginUrl;
  if (process.env.NODE_ENV == "development") {
    wxLoginUrl = loginUrl;
  } else {
    wxLoginUrl = await memberService.getLoginUrl(loginUrl);
  }

  if (wxLoginUrl) {
    next(false);
    location.href = wxLoginUrl;
    return false;
  }
}

export default router;
